(function() {
  function getCk(n) {
    var m = document.cookie.match(new RegExp('(^| )' + n + '=([^;]+)'));
    return m ? decodeURIComponent(m[2]) : null;
  }
  function esc(s){ return (s==null?'':String(s)).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function setCk(n, v){ try { document.cookie = n + '=' + encodeURIComponent(v) + '; path=/; max-age=2592000'; } catch(e){} }
  function delCk(n){ try { document.cookie = n + '=; path=/; max-age=0'; } catch(e){} }
  // BE-style "Change" = REMOVE the selected item, then go to its catalog to re-pick
  // (Change on the diamond clears the diamond -> lab-diamonds; Change on the setting
  // clears the setting -> engagement-rings). "View" keeps the item and opens its PDP.
  window.__spBuilderChange = function(kind, url){
    try {
      if (kind === 'setting') { delCk('_ring'); delCk('_ring_ts'); }
      else if (kind === 'diamond') { delCk('_diamonmd'); delCk('_diamond'); delCk('_dia_ts'); }
      delCk('_pendfinal');
    } catch(e){}
    if (url) window.location.href = url;
  };
  // Write-time timestamps: when the customer anchors a choice, stamp it; and clear
  // a STALE opposite selection (old/untimestamped leftover) so the build order and
  // the "pick a setting" routing reflect the CURRENT build (no Start Over needed).
  document.addEventListener('click', function(ev){
    var el = ev.target && ev.target.closest ? ev.target.closest('button, a') : null;
    if (!el) return;
    var txt = (el.textContent || '').trim().toLowerCase();
    var now = Date.now(), STALE = 20 * 60 * 1000;
    if (/add to ring/.test(txt) || (el.getAttribute && el.getAttribute('data-add-to-ring') !== null)) {
      setCk('_dia_ts', String(now));
      var r = getCk('_ring'), rt = parseInt(getCk('_ring_ts') || '0', 10);
      if (r && (!rt || (now - rt) > STALE)) { delCk('_ring'); delCk('_ring_ts'); delCk('_buildorder'); }
      else if (r) { setCk('_pendfinal', '1'); }
    } else if (el.id === 'choosethissetting' || /choose this setting/.test(txt)) {
      setCk('_ring_ts', String(now));
      var d = getCk('_diamonmd') || getCk('_diamond'), dt = parseInt(getCk('_dia_ts') || '0', 10);
      if (d && (!dt || (now - dt) > STALE)) { delCk('_diamonmd'); delCk('_diamond'); delCk('_dia_ts'); delCk('_buildorder'); }
    }
  }, true);

  var wrap = document.getElementById('sp-global-progress-wrap');
  if (!wrap) return;

  if (document.querySelector('[data-no-builder="true"]')) {
    wrap.style.display = 'none';
    return;
  }

  var ctx = wrap.getAttribute('data-page-context');

  // Remember the diamond catalog's active filters so "Change diamond" can restore
  // them later (format-agnostic: we just stash the current querystring).
  function captureDiamondFilters(){
    var q = (window.location.search || '').replace(/^\?/, '');
    q = q.split('&').filter(function(p){ return p && p.indexOf('preview_theme_id=') !== 0; }).join('&');
    setCk('_dfilters', q);
  }
  if (ctx === 'diamond-collection') {
    captureDiamondFilters();
    window.addEventListener('pagehide', captureDiamondFilters);
  }

  // Auto-clear STALE build state (replaces the removed Start Over): a real pick now
  // carries a timestamp set at the anchor click; a selection with NO timestamp is a
  // pre-fix leftover, and any build untouched for >45min is abandoned -> drop it so a
  // reload of the SAME tab starts clean, no new tab or button needed.
  (function(){
    var now = Date.now(), TTL = 45 * 60 * 1000;
    var touched = parseInt(getCk('_b_touched') || '0', 10);
    var expired = touched && (now - touched > TTL);
    if (getCk('_diamonmd') && (!getCk('_dia_ts') || expired)) { delCk('_diamonmd'); delCk('_diamond'); delCk('_dia_ts'); }
    if (getCk('_ring') && (!getCk('_ring_ts') || expired)) { delCk('_ring'); delCk('_ring_ts'); delCk('_buildorder'); }
    setCk('_b_touched', String(now));
  })();
  var diamondRaw = getCk('_diamonmd') || getCk('_diamond');
  var diamond = null;
  if (diamondRaw) { try { diamond = JSON.parse(diamondRaw); } catch(e) {} }
  var hasDiamond = !!(diamond && diamond.sku);

  var ringRaw = getCk('_ring');
  var ring = null;
  if (ringRaw) { try { ring = JSON.parse(ringRaw); } catch(e) {} }
  var hasRing = !!(ring && ring.handle);

  var isFinal = window.location.search.indexOf('view=final-ring') > -1;

  var onSettingPage = (ctx === 'settings-collection' || ctx === 'settings-product');
  var onDiamondPage = (ctx === 'diamond-collection' || ctx === 'diamond-product');

  // BUILD ORDER — follow the path the customer actually built. The first item
  // they SELECT fixes the order (setting-first vs diamond-first) and it is
  // persisted so it never flips later (e.g. on the final page once both exist).
  // Persisted so it never flips later.
  // Order by write-time timestamps so a freshly picked item out-ranks a STALE
  // leftover (leftover has no _dia_ts/_ring_ts because it predates the pick).
  var dTs = parseInt(getCk('_dia_ts') || '0', 10);
  var rTs = parseInt(getCk('_ring_ts') || '0', 10);
  var buildOrder;
  if (hasDiamond && hasRing) {
    if (dTs && rTs)      buildOrder = (dTs <= rTs) ? 'diamond' : 'setting';
    else if (dTs)        buildOrder = 'diamond';
    else if (rTs)        buildOrder = 'setting';
    else                 buildOrder = getCk('_buildorder') || 'setting';
  } else if (hasDiamond) buildOrder = 'diamond';
  else if (hasRing)      buildOrder = 'setting';
  else                   buildOrder = onDiamondPage ? 'diamond' : (getCk('_buildorder') || 'setting');
  setCk('_buildorder', buildOrder);
  var settingFirst = (buildOrder === 'setting');

  // SHAPE MATCH + COMPLETE: adding a diamond to a setting whose shape differs should
  // auto-switch the setting to the diamond's shape (same metal) and land on step 3 —
  // NOT bounce to the catalog to re-pick. Gated by _pendfinal (set only on the
  // add-diamond path) so "Change setting" still routes to the catalog.
  if ((isFinal || getCk('_pendfinal')) && hasDiamond && hasRing) {
    (function(){
      if (window.__spShapeGuard) return; window.__spShapeGuard = true;
      function canonShape(s){ if(!s) return ''; var l=String(s).toLowerCase().trim(); if(l==='moval')return 'oval'; if(l==='french marquise')return 'marquise'; return l; }
      var dshape; try { dshape = canonShape(diamond.canonical_shape || diamond.shape); } catch(e){ delCk('_pendfinal'); return; }
      var handle = ring && ring.handle; if (!dshape || !handle) { delCk('_pendfinal'); return; }
      var curVid = String((ring && ring.vid) || (location.search.match(/[?&]variant=(\d+)/)||[])[1] || '');
      var sku = diamond.sku;
      fetch(handle.split('?')[0] + '.js', { credentials: 'same-origin' }).then(function(r){ return r.json(); }).then(function(prod){
        if (!prod || !prod.options || !prod.variants) { delCk('_pendfinal'); return; }
        var shapeIdx = 0, metalIdx = 0, oi, on, pos;
        for (oi = 0; oi < prod.options.length; oi++){ on = prod.options[oi]; on = (on && on.name) ? on.name : on; pos = (prod.options[oi] && prod.options[oi].position) ? prod.options[oi].position : (oi + 1); if (on === 'Shape') shapeIdx = pos; else if (on === 'Color') metalIdx = pos; }
        if (!shapeIdx) { delCk('_pendfinal'); return; }
        var cur = null, k;
        for (k = 0; k < prod.variants.length; k++){ if (String(prod.variants[k].id) === curVid) { cur = prod.variants[k]; break; } }
        var targetVid = curVid;
        var alreadyMatch = cur && (canonShape(cur['option' + shapeIdx]) === dshape);
        if (!alreadyMatch) {
          var curMetal = (cur && metalIdx) ? cur['option' + metalIdx] : null;
          var match = null, any = null;
          for (k = 0; k < prod.variants.length; k++){ var v = prod.variants[k]; if (v.available === false) continue; if (canonShape(v['option' + shapeIdx]) === dshape){ if (!any) any = v; if (metalIdx && v['option' + metalIdx] === curMetal) { match = v; break; } } }
          match = match || any;
          if (!match) { delCk('_pendfinal'); return; }   // setting doesn't come in this shape -> leave legacy behavior
          targetVid = String(match.id);
          try { var rr = JSON.parse(getCk('_ring')); rr.vid = targetVid; setCk('_ring', JSON.stringify(rr)); } catch(e){}
        }
        delCk('_pendfinal');
        var curOnFinal = isFinal && (String((location.search.match(/[?&]variant=(\d+)/)||[])[1] || '') === targetVid);
        if (!curOnFinal) {
          location.replace(handle.split('?')[0] + '?variant=' + targetVid + '&view=final-ring' + (sku ? ('&diamond=' + encodeURIComponent(sku)) : ''));
        }
      }).catch(function(){ delCk('_pendfinal'); });
    })();
  }

  // STATE is the current page's progress — decoupled from order so it never flips.
  function stateOf(kind) {
    if (kind === 'complete') return isFinal ? 'active' : 'upcoming';
    if (isFinal) return 'completed';
    if (kind === 'setting') {
      if (onSettingPage) return 'active';
      return hasRing ? 'completed' : 'upcoming';
    }
    if (onDiamondPage) return 'active';
    return hasDiamond ? 'completed' : 'upcoming';
  }
  var settingStep  = { label: 'Choose a Setting',     state: stateOf('setting')  };
  var diamondStep  = { label: 'Choose a Diamond',     state: stateOf('diamond')  };
  var completeStep = { label: 'Complete Your Ring',   state: stateOf('complete') };

  var steps = settingFirst
    ? [settingStep, diamondStep, completeStep]
    : [diamondStep, settingStep, completeStep];

  var icons = {
    'Setting': '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="15" r="6"/><path d="M12 9V4"/><path d="M9 5.5L12 4l3 1.5"/><path d="M8 10l-1-3"/><path d="M16 10l1-3"/></svg>',
    'Diamond': '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 6.5h15l3 5-10.5 11L1.5 11.5z"/><path d="M1.5 11.5h21"/><path d="M12 22.5l-4-11 4-5 4 5-4 11"/><path d="M7.5 6.5l4.5 5 4.5-5"/></svg>',
    'Complete': '<svg viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="15" r="6"/><path d="M9.5 10.5l2.5-4 2.5 4"/><path d="M9.5 10.5h5"/><path d="M8.5 11l-0.5 0.5"/><path d="M15.5 11l0.5 0.5"/></svg>'
  };

  var html = '<div class="sp-progress"><div class="sp-progress__lead">Design Your Engagement Ring</div>';
  for (var i = 0; i < steps.length; i++) {
    var s = steps[i];
    var cls = 'sp-progress__step';
    if (s.state === 'active') cls += ' sp-progress__step--active';
    else if (s.state === 'completed') cls += ' sp-progress__step--completed';

    var isDiamondStep = s.label.indexOf('Diamond') > -1;
    var isSettingStep = s.label.indexOf('Setting') > -1;
    var iconKey = isSettingStep ? 'Setting' : (isDiamondStep ? 'Diamond' : 'Complete');

    var smallText, mainText;
    if (isSettingStep) {
      if (hasRing) {
        smallText = (s.state === 'active') ? 'Changing your' : 'Your setting';
        mainText = 'SETTING';
      } else {
        smallText = 'Select your'; mainText = 'SETTING';
      }
    } else if (isDiamondStep) {
      if (hasDiamond) {
        smallText = (s.state === 'active') ? 'Changing your' : 'Your stone';
        var parts = [];
        if (diamond.carat)   parts.push(String(diamond.carat) + 'CT');
        if (diamond.shape)   parts.push(String(diamond.shape).toUpperCase());
        if (diamond.color)   parts.push(String(diamond.color).toUpperCase());
        if (diamond.clarity) parts.push(String(diamond.clarity).toUpperCase());
        mainText = parts.length ? parts.join(' · ') : 'STONE';
      } else {
        smallText = 'Select your'; mainText = 'STONE';
      }
    } else {
      smallText = 'Complete your'; mainText = 'RING';
    }

    var useDiamondThumb = isDiamondStep && hasDiamond && s.state === 'completed';
    var useSettingThumb = isSettingStep && hasRing && s.state === 'completed';
    var thumbSrc = null;
    var dataAttr = '';
    if (useDiamondThumb) {
      thumbSrc = diamond.cover_pic || diamond.image || diamond.img || diamond.thumbnail;
    } else if (useSettingThumb) {
      dataAttr = ' data-setting-thumb';
    }
    if (useDiamondThumb || useSettingThumb) cls += ' sp-progress__step--has-thumb';

    // Change/catalog url — now used ONLY by the explicit "Change" link (removes + re-pick).
    var clickUrl = '';
    if (isSettingStep) {
      if (s.state === 'completed') {
        var shp = diamond && (diamond.canonical_shape || diamond.shape);
        clickUrl = '/collections/engagement-rings' + (shp ? ('?filter.v.option.shape=' + encodeURIComponent(shp)) : '');
      } else {
        clickUrl = '/collections/engagement-rings';
      }
    } else if (isDiamondStep) {
      if (s.state === 'completed') {
        var df = getCk('_dfilters');
        clickUrl = '/collections/lab-diamonds' + (df ? ('?' + df) : '');
      } else {
        clickUrl = '/collections/lab-diamonds';
      }
    }
    var changeKind = isSettingStep ? 'setting' : (isDiamondStep ? 'diamond' : '');

    // VIEW url = the item's OWN product page (computed for completed steps).
    var viewUrl = '';
    if (s.state === 'completed') {
      if (isSettingStep) {
        if (ring && ring.handle) {
          viewUrl = (ring.handle.indexOf('/products/') === 0) ? ring.handle : ('/products/' + ring.handle);
          if (ring.vid) viewUrl += (viewUrl.indexOf('?') > -1 ? '&' : '?') + 'variant=' + ring.vid;
        } else if (location.pathname.indexOf('/products/') === 0 && location.search.indexOf('view=final-ring') > -1) {
          var svm = location.search.match(/[?&]variant=([^&]+)/);
          viewUrl = location.pathname + (svm ? ('?variant=' + svm[1]) : '');
        }
      } else if (isDiamondStep) {
        if (diamond && diamond.sku) {
          viewUrl = '/products/diamonds?sku=' + encodeURIComponent(diamond.sku);
        } else {
          var dvm = location.search.match(/[?&]diamond=([^&]+)/);
          if (dvm) { viewUrl = '/products/diamonds?sku=' + dvm[1]; }
        }
      }
    }

    // A COMPLETED step: clicking the step itself (the arrow) = VIEW — open the item's page and
    // KEEP it selected in the bag. Only the explicit "Change" link removes it (owner 2026-07-08).
    // Active/upcoming steps just navigate to their catalog.
    var clickAttr = '';
    var clickCls = '';
    if (s.state === 'completed') {
      if (viewUrl) { clickAttr = ' onclick="window.location.href=\'' + viewUrl + '\'"'; clickCls = ' sp-progress__step--clickable'; }
    } else if (clickUrl) {
      clickAttr = ' onclick="window.location.href=\'' + clickUrl + '\'"'; clickCls = ' sp-progress__step--clickable';
    }

    html += '<div class="' + cls + clickCls + '"' + clickAttr + '>';
    html += '<div class="sp-progress__num">' + (i + 1) + '</div>';
    // Completed steps get BE-style "View" (open the item's page, keep it) + "Change" (remove + re-pick).
    var actions = '';
    if (s.state === 'completed' && clickUrl && changeKind) {
      var viewLink = viewUrl ? '<a href="' + viewUrl + '" class="sp-progress__view" onclick="event.stopPropagation()">View</a>' : '';
      var changeLink = '<span class="sp-progress__change" role="button" tabindex="0" onclick="event.stopPropagation();window.__spBuilderChange(\'' + changeKind + '\',\'' + clickUrl + '\')">Change</span>';
      actions = '<span class="sp-progress__actions">' + viewLink + changeLink + '</span>';
    }
    html += '<div class="sp-progress__text"' + (isSettingStep ? ' data-setting-text' : (isDiamondStep ? ' data-diamond-text' : '')) + '><span class="sp-progress__text-small">' + esc(smallText) + '</span><span class="sp-progress__text-main">' + esc(mainText) + '</span>' + actions + '</div>';
    if (thumbSrc) {
      html += '<div class="sp-progress__thumb"><img src="' + esc(thumbSrc) + '" alt="' + esc(diamond && diamond.shape || 'Diamond') + '"></div>';
    } else if (useSettingThumb) {
      html += '<div class="sp-progress__thumb"' + dataAttr + '></div>';
    } else {
      html += '<div class="sp-progress__icon">' + icons[iconKey] + '</div>';
    }
    html += '</div>';
  }
  html += '</div>';

  var container = wrap.querySelector('.sp-progress-container');
  if (container) container.innerHTML = html;

  // v47: async fetch only overwrites text on COMPLETED setting step (not active)
  if (hasRing && ring.handle) {
    var handle = ring.handle.indexOf('/products/') === 0 ? ring.handle : ('/products/' + ring.handle);
    fetch(handle + '.js', { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if (!p) return;
        var vid = parseInt(ring.vid, 10);
        var v = (p.variants || []).find(function(x){ return x.id === vid; });
        var imgUrl = (v && v.featured_image && (v.featured_image.src || v.featured_image))
                     || p.featured_image
                     || (p.images && p.images[0])
                     || null;
        if (imgUrl && imgUrl.indexOf('//') === 0) imgUrl = 'https:' + imgUrl;

        var slot = document.querySelector('.sp-progress__thumb[data-setting-thumb]');
        if (slot && imgUrl) {
          var img = document.createElement('img');
          img.src = imgUrl;
          img.alt = p.title || 'Setting';
          slot.appendChild(img);
        }
        // Only replace the main label on completed steps (thumbnail was already
        // gated on completed). Prevents "Select your SUN BELT SETTING" hybrid.
        var txt = document.querySelector('.sp-progress__step--completed [data-setting-text] .sp-progress__text-main');
        if (txt && p.title) {
          txt.textContent = p.title.toUpperCase();
        }
      })
      .catch(function(){});
  }

  /* Start Over removed 2026-07-07 — BE pattern uses per-step Change links */

})();
